import '../styles/app.scss';
import './_images';
import './_fonts';
import { openMegaMenuDropdown } from './components/OpenMegaMenuDropdown';
import { stickyHeader } from './components/StickyHeader';
import { smoothScroll } from './components/SmoothScroll';
import { filter } from './components/Filter';
import { researchPopup } from './components/ResearchPopup';
import { courcesNav } from './components/CourcesNav';
import { openAccordion } from './components/OpenAccordion';

window.addEventListener('DOMContentLoaded', () => {
	smoothScroll();
	stickyHeader();
	openMegaMenuDropdown();
	filter();
	researchPopup();
	openAccordion();
	courcesNav();
});
